import type React from "react"
import Image from "@/src/components/Image"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface SocialLoginButtonProps {
  provider: "phone" | "google" | "facebook" | "line"
  children?: React.ReactNode
  onClick?: () => void
  className?: string
  disabled?: boolean
}

const providerStyles = {
  phone: "text-white hover:opacity-90",
  google: "text-white hover:opacity-90",
  facebook: "text-white hover:opacity-90",
  line: "text-white hover:opacity-90",
}

const providerIcons = {
  phone: "/icons/icon-phone.png",
  google: "/icons/icon-google.png",
  facebook: "/icons/icon-facebook.png",
  line: "/icons/icon-line.png",
}

export function SocialLoginButton({ provider, children, onClick, className, disabled }: SocialLoginButtonProps) {
  const getProviderBgStyle = (provider: string) => {
    switch (provider) {
      case "phone":
        return { backgroundColor: "var(--phone-green)" }
      case "google":
        return { backgroundColor: "var(--google-red)" }
      case "facebook":
        return { backgroundColor: "var(--facebook-blue)" }
      case "line":
        return { backgroundColor: "var(--line-green)" }
      default:
        return {}
    }
  }

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      style={getProviderBgStyle(provider)}
      className={cn(
        "w-full py-3 text-base font-medium flex items-center justify-center gap-3 rounded-lg transition-all duration-200 hover:shadow-lg border-0 cursor-pointer",
        providerStyles[provider],
        disabled && "opacity-50 cursor-not-allowed",
        className,
      )}
      variant="default"
    >
      <Image
        src={providerIcons[provider] || "/placeholder.svg"}
        alt={`${provider} icon`}
        width={20}
        height={20}
        className="object-contain"
      />
      {children}
    </Button>
  )
}
